// extracted by mini-css-extract-plugin
export default {"main":"Main_main__9eKbG","cover":"Main_cover__PLNk7","flex_col":"Main_flex_col__6nHbh","section2":"Main_section2__THKB-"};